import React from "react";
import ECharts from "echarts-for-react";

export default function NetworkMapComponent() {
	// Category definitions
	const categories = [
		{ name: "Core", itemStyle: { color: "#FF6B6B" } },
		{ name: "Zone", itemStyle: { color: "#9D84B7" } },
		{ name: "Server", itemStyle: { color: "#4D96FF" } },
		{ name: "Workstation", itemStyle: { color: "#32C77A" } },
		{ name: "PLC", itemStyle: { color: "#FFB84D" } },
		{ name: "Device", itemStyle: { color: "#00D4FF" } },
		{ name: "Network Device", itemStyle: { color: "#FF8C42" } },
		{ name: "Security", itemStyle: { color: "#FF6B9D" } },
	];

	const categoryIndex = {
		core: 0,
		zone: 1,
		server: 2,
		workstation: 3,
		plc: 4,
		device: 5,
		"network-device": 6,
		security: 7,
	};

	// Network nodes representing OT infrastructure - organized hierarchically with detailed data
	const networkNodes = [
		// Core Infrastructure
		{ id: "core", name: "Core Network", category: categoryIndex.core, value: 120, symbolSize: 40, status: "Online", health: "Excellent", uptime: "99.9%", bandwidth: "10 Gbps", vulnerabilities: 0 },
		{ id: "firewall", name: "Firewall-01", category: categoryIndex["network-device"], value: 90, symbolSize: 35, status: "Online", health: "Excellent", uptime: "99.8%", bandwidth: "5 Gbps", vulnerabilities: 0 },
		{ id: "log-server", name: "Log Server", category: categoryIndex.server, value: 60, symbolSize: 25, status: "Online", health: "Good", uptime: "99.5%", bandwidth: "2 Gbps", vulnerabilities: 1 },

		// Management Zone (grouped)
		{ id: "mgmt-zone", name: "Management Zone", category: categoryIndex.zone, value: 85, symbolSize: 35, status: "Online", health: "Excellent", uptime: "99.7%", devices: 3, vulnerabilities: 0 },
		{ id: "mgmt-server", name: "MGMT-01", category: categoryIndex.server, value: 65, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.6%", cpu: "32%", memory: "48%", vulnerabilities: 0 },
		{ id: "monitor-station", name: "Monitor-WS-01", category: categoryIndex.workstation, value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "99.4%", cpu: "25%", memory: "42%", vulnerabilities: 1 },
		{ id: "ntp-server", name: "NTP Server", category: categoryIndex.server, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "99.9%", bandwidth: "100 Mbps", vulnerabilities: 0 },

		// Control Zone (grouped)
		{ id: "control-zone", name: "Control Zone", category: categoryIndex.zone, value: 95, symbolSize: 38, status: "Online", health: "Excellent", uptime: "99.8%", devices: 4, vulnerabilities: 1 },
		{ id: "scada-main", name: "SCADA-01", category: categoryIndex.server, value: 75, symbolSize: 28, status: "Online", health: "Excellent", uptime: "99.8%", cpu: "45%", memory: "61%", vulnerabilities: 0 },
		{ id: "hmi-01", name: "HMI-01", category: categoryIndex.workstation, value: 55, symbolSize: 20, status: "Online", health: "Excellent", uptime: "99.7%", cpu: "38%", memory: "52%", vulnerabilities: 0 },
		{ id: "hmi-02", name: "HMI-02", category: categoryIndex.workstation, value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "99.3%", cpu: "35%", memory: "48%", vulnerabilities: 1 },
		{ id: "historian-01", name: "Historian", category: categoryIndex.server, value: 60, symbolSize: 22, status: "Online", health: "Good", uptime: "99.5%", storage: "78%", vulnerabilities: 2 },

		// Field Devices Zone (grouped)
		{ id: "field-zone", name: "Field Devices", category: categoryIndex.zone, value: 95, symbolSize: 38, status: "Online", health: "Good", uptime: "99.2%", devices: 5, vulnerabilities: 3 },
		{ id: "plc-01", name: "PLC-01", category: categoryIndex.plc, value: 60, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.9%", cpu: "52%", memory: "68%", vulnerabilities: 0 },
		{ id: "plc-02", name: "PLC-02", category: categoryIndex.plc, value: 60, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.9%", cpu: "48%", memory: "65%", vulnerabilities: 0 },
		{ id: "vfd-01", name: "VFD-01", category: categoryIndex.device, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "98.9%", power: "85 kW", temp: "42°C", vulnerabilities: 1 },
		{ id: "vfd-02", name: "VFD-02", category: categoryIndex.device, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "99.1%", power: "88 kW", temp: "41°C", vulnerabilities: 1 },
		{ id: "sensor-net", name: "Sensor Network", category: categoryIndex.device, value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "98.5%", sensors: "12", coverage: "95%", vulnerabilities: 2 },
		{ id: "io-module", name: "I/O Module-01", category: categoryIndex.device, value: 45, symbolSize: 16, status: "Online", health: "Excellent", uptime: "99.8%", channels: "32", utilization: "72%", vulnerabilities: 0 },

		// Remote Site (grouped)
		{ id: "remote-site", name: "Remote Site", category: categoryIndex.zone, value: 80, symbolSize: 32, status: "Online", health: "Good", uptime: "98.7%", devices: 3, link_quality: "85%", vulnerabilities: 2 },
		{ id: "remote-gateway", name: "Remote Gateway", category: categoryIndex["network-device"], value: 65, symbolSize: 24, status: "Online", health: "Good", uptime: "98.8%", bandwidth: "100 Mbps", latency: "45ms", vulnerabilities: 1 },
		{ id: "remote-plc", name: "Remote-PLC", category: categoryIndex.plc, value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "98.5%", cpu: "42%", memory: "55%", vulnerabilities: 1 },
		{ id: "remote-cam", name: "IP-Cam-01", category: categoryIndex.device, value: 45, symbolSize: 16, status: "Online", health: "Good", uptime: "99.0%", resolution: "1080p", fps: "30", vulnerabilities: 2 },

		// Security & Monitoring
		{ id: "ips-ids", name: "IPS/IDS", category: categoryIndex.security, value: 75, symbolSize: 28, status: "Online", health: "Excellent", uptime: "99.9%", threats_detected: "12", blocked: "8", vulnerabilities: 0 },
		{ id: "waf", name: "WAF-01", category: categoryIndex.security, value: 65, symbolSize: 24, status: "Online", health: "Good", uptime: "99.7%", requests: "50K/min", threats: "3", vulnerabilities: 1 },

		// External/Cloud Nodes (Spiral Galaxy Pattern)
		// Cloud Services
		{ id: "cloud-backup", name: "Cloud Backup", category: categoryIndex.server, value: 55, symbolSize: 20, status: "Online", health: "Excellent", uptime: "99.99%", storage: "500 GB", bandwidth: "1 Gbps", vulnerabilities: 0 },
		{ id: "cloud-sync", name: "Cloud Sync", category: categoryIndex.server, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "99.5%", storage: "1 TB", bandwidth: "500 Mbps", vulnerabilities: 1 },
		{ id: "cloud-analytics", name: "Analytics Cloud", category: categoryIndex.server, value: 60, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.95%", cpu: "65%", memory: "72%", vulnerabilities: 0 },

		// Third-party Integrations
		{ id: "api-gateway", name: "API Gateway", category: categoryIndex["network-device"], value: 70, symbolSize: 24, status: "Online", health: "Good", uptime: "99.8%", bandwidth: "2 Gbps", requests: "100K/min", vulnerabilities: 1 },
		{ id: "iot-platform", name: "IoT Platform", category: categoryIndex.device, value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "99.4%", devices_connected: "256", bandwidth: "500 Mbps", vulnerabilities: 2 },
		{ id: "erp-system", name: "ERP System", category: categoryIndex.server, value: 75, symbolSize: 26, status: "Online", health: "Excellent", uptime: "99.9%", cpu: "38%", memory: "54%", vulnerabilities: 0 },

		// Monitoring & Analytics
		{ id: "siem", name: "SIEM System", category: categoryIndex.security, value: 70, symbolSize: 26, status: "Online", health: "Excellent", uptime: "99.95%", events_per_sec: "5000", storage: "95%", vulnerabilities: 0 },
		{ id: "splunk", name: "Splunk Server", category: categoryIndex.server, value: 65, symbolSize: 22, status: "Online", health: "Good", uptime: "99.7%", storage: "85%", indexing_rate: "500K/day", vulnerabilities: 1 },
		{ id: "prometheus", name: "Prometheus", category: categoryIndex.device, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "99.6%", metrics_stored: "2M", scrape_interval: "30s", vulnerabilities: 0 },

		// Backup & Disaster Recovery
		{ id: "dr-center", name: "DR Center", category: categoryIndex.zone, value: 80, symbolSize: 30, status: "Online", health: "Good", uptime: "99.8%", devices: "50", rpo: "1 hour", vulnerabilities: 1 },
		{ id: "backup-vault", name: "Backup Vault", category: categoryIndex.server, value: 60, symbolSize: 20, status: "Online", health: "Good", uptime: "99.5%", storage: "98%", retention: "90 days", vulnerabilities: 0 },

		// External Connectivity
		{ id: "vpn-gateway", name: "VPN Gateway", category: categoryIndex["network-device"], value: 65, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.9%", connections: "45", bandwidth: "1 Gbps", vulnerabilities: 0 },
		{ id: "wan-accelerator", name: "WAN Accelerator", category: categoryIndex["network-device"], value: 55, symbolSize: 20, status: "Online", health: "Good", uptime: "99.4%", optimization: "78%", latency: "8ms", vulnerabilities: 1 },
		{ id: "dns-server", name: "DNS Server", category: categoryIndex.server, value: 50, symbolSize: 18, status: "Online", health: "Excellent", uptime: "99.99%", queries_per_sec: "1000", cache_hit: "95%", vulnerabilities: 0 },

		// Vendor & Support Systems
		{ id: "vendor-portal", name: "Vendor Portal", category: categoryIndex.server, value: 50, symbolSize: 18, status: "Online", health: "Good", uptime: "99.2%", users: "120", bandwidth: "200 Mbps", vulnerabilities: 2 },
		{ id: "cert-authority", name: "CA Server", category: categoryIndex.security, value: 60, symbolSize: 22, status: "Online", health: "Excellent", uptime: "99.98%", certificates: "5000", revocations: "12", vulnerabilities: 0 },
	];

	// Network connections - hierarchical with more relationships
	const networkLinks = [
		// Core connections
		{ source: "core", target: "firewall", value: 5 },
		{ source: "firewall", target: "ips-ids", value: 4 },
		{ source: "firewall", target: "waf", value: 3 },
		{ source: "firewall", target: "log-server", value: 3 },

		// Zone connections
		{ source: "firewall", target: "mgmt-zone", value: 4 },
		{ source: "firewall", target: "control-zone", value: 5 },
		{ source: "firewall", target: "field-zone", value: 4 },

		// Management Zone internal
		{ source: "mgmt-zone", target: "mgmt-server", value: 3 },
		{ source: "mgmt-zone", target: "ntp-server", value: 2 },
		{ source: "mgmt-server", target: "monitor-station", value: 2 },
		{ source: "mgmt-server", target: "ntp-server", value: 2 },

		// Control Zone internal
		{ source: "control-zone", target: "scada-main", value: 3 },
		{ source: "control-zone", target: "historian-01", value: 2 },
		{ source: "scada-main", target: "hmi-01", value: 2 },
		{ source: "scada-main", target: "hmi-02", value: 2 },
		{ source: "scada-main", target: "historian-01", value: 2 },

		// Field Devices Zone internal
		{ source: "field-zone", target: "plc-01", value: 2 },
		{ source: "field-zone", target: "plc-02", value: 2 },
		{ source: "field-zone", target: "sensor-net", value: 2 },
		{ source: "field-zone", target: "io-module", value: 2 },
		{ source: "plc-01", target: "vfd-01", value: 1 },
		{ source: "plc-01", target: "io-module", value: 1 },
		{ source: "plc-02", target: "vfd-02", value: 1 },
		{ source: "plc-02", target: "sensor-net", value: 1 },

		// Remote Site
		{ source: "core", target: "remote-site", value: 3 },
		{ source: "remote-site", target: "remote-gateway", value: 2 },
		{ source: "remote-gateway", target: "remote-plc", value: 2 },
		{ source: "remote-gateway", target: "remote-cam", value: 1 },

		// Cross-zone monitoring
		{ source: "scada-main", target: "log-server", value: 2 },
		{ source: "control-zone", target: "ips-ids", value: 2 },
		{ source: "field-zone", target: "ips-ids", value: 1 },
		{ source: "log-server", target: "monitor-station", value: 1 },
		{ source: "historian-01", target: "log-server", value: 1 },

		// External Cloud Connections (Galaxy Pattern)
		{ source: "firewall", target: "cloud-backup", value: 3 },
		{ source: "firewall", target: "cloud-sync", value: 2 },
		{ source: "firewall", target: "cloud-analytics", value: 2 },

		// API & Integration Connections
		{ source: "firewall", target: "api-gateway", value: 3 },
		{ source: "api-gateway", target: "iot-platform", value: 2 },
		{ source: "api-gateway", target: "erp-system", value: 2 },

		// Monitoring & SIEM Connections
		{ source: "firewall", target: "siem", value: 3 },
		{ source: "siem", target: "splunk", value: 2 },
		{ source: "siem", target: "prometheus", value: 2 },
		{ source: "log-server", target: "siem", value: 2 },
		{ source: "ips-ids", target: "siem", value: 2 },

		// Disaster Recovery Connections
		{ source: "firewall", target: "dr-center", value: 2 },
		{ source: "dr-center", target: "backup-vault", value: 2 },
		{ source: "log-server", target: "backup-vault", value: 1 },

		// External Gateway Connections
		{ source: "firewall", target: "vpn-gateway", value: 3 },
		{ source: "firewall", target: "wan-accelerator", value: 2 },
		{ source: "vpn-gateway", target: "remote-site", value: 2 },
		{ source: "wan-accelerator", target: "remote-site", value: 1 },

		// DNS & Certificate Connections
		{ source: "firewall", target: "dns-server", value: 2 },
		{ source: "firewall", target: "cert-authority", value: 2 },
		{ source: "ntp-server", target: "dns-server", value: 1 },

		// Vendor & Support Connections
		{ source: "firewall", target: "vendor-portal", value: 2 },
		{ source: "firewall", target: "cert-authority", value: 1 },
		{ source: "siem", target: "vendor-portal", value: 1 },

		// Cloud Backup Links
		{ source: "cloud-backup", target: "historian-01", value: 1 },
		{ source: "cloud-sync", target: "scada-main", value: 1 },
		{ source: "cloud-analytics", target: "siem", value: 1 },
	];

	const option = {
		title: {
			text: "",
		},
		tooltip: {
			trigger: "item",
			backgroundColor: "rgba(20, 25, 45, 0.95)",
			borderColor: "#3B82F6",
			borderWidth: 2,
			textStyle: {
				color: "#fff",
				fontSize: 11,
			},
			confine: true,
			padding: [10, 15],
			formatter: (params) => {
				if (params.dataType === "node") {
					const node = params.data;
					const category = categories[node.category].name;
					let html = `<div style="text-align: left;">`;
					html += `<strong style="color: #3B82F6; font-size: 12px;">${node.name}</strong><br/>`;
					html += `<span style="color: #999; font-size: 10px;">Category: ${category}</span><br/>`;
					html += `<hr style="margin: 5px 0; border: none; border-top: 1px solid #444;"/>`;
					
					// Display all available attributes
					if (node.status) html += `<span>Status: <strong style="color: #10b981;">${node.status}</strong></span><br/>`;
					if (node.health) html += `<span>Health: <strong style="color: #3B82F6;">${node.health}</strong></span><br/>`;
					if (node.uptime) html += `<span>Uptime: <strong>${node.uptime}</strong></span><br/>`;
					if (node.vulnerabilities !== undefined) html += `<span>Vulnerabilities: <strong style="color: ${node.vulnerabilities > 2 ? '#ef4444' : node.vulnerabilities > 0 ? '#f59e0b' : '#10b981'};">${node.vulnerabilities}</strong></span><br/>`;
					
					// CPU, Memory
					if (node.cpu) html += `<span>CPU: <strong>${node.cpu}</strong></span><br/>`;
					if (node.memory) html += `<span>Memory: <strong>${node.memory}</strong></span><br/>`;
					
					// Bandwidth, Power, Temperature
					if (node.bandwidth) html += `<span>Bandwidth: <strong>${node.bandwidth}</strong></span><br/>`;
					if (node.power) html += `<span>Power: <strong>${node.power}</strong></span><br/>`;
					if (node.temp) html += `<span>Temperature: <strong>${node.temp}</strong></span><br/>`;
					
					// Device counts and other metrics
					if (node.devices) html += `<span>Devices: <strong>${node.devices}</strong></span><br/>`;
					if (node.sensors) html += `<span>Sensors: <strong>${node.sensors}</strong></span><br/>`;
					if (node.channels) html += `<span>Channels: <strong>${node.channels}</strong></span><br/>`;
					
					// Storage, Resolution, FPS
					if (node.storage) html += `<span>Storage Usage: <strong>${node.storage}</strong></span><br/>`;
					if (node.resolution) html += `<span>Resolution: <strong>${node.resolution}</strong></span><br/>`;
					if (node.fps) html += `<span>FPS: <strong>${node.fps}</strong></span><br/>`;
					
					// Coverage, Utilization, Link Quality
					if (node.coverage) html += `<span>Coverage: <strong>${node.coverage}</strong></span><br/>`;
					if (node.utilization) html += `<span>Utilization: <strong>${node.utilization}</strong></span><br/>`;
					if (node.link_quality) html += `<span>Link Quality: <strong>${node.link_quality}</strong></span><br/>`;
					
					// Latency, Threats, Requests
					if (node.latency) html += `<span>Latency: <strong>${node.latency}</strong></span><br/>`;
					if (node.threats_detected) html += `<span>Threats Detected: <strong style="color: #ef4444;">${node.threats_detected}</strong></span><br/>`;
					if (node.blocked) html += `<span>Threats Blocked: <strong style="color: #10b981;">${node.blocked}</strong></span><br/>`;
					if (node.threats) html += `<span>Active Threats: <strong style="color: #f59e0b;">${node.threats}</strong></span><br/>`;
					if (node.requests) html += `<span>Requests/min: <strong>${node.requests}</strong></span><br/>`;
					
					html += `</div>`;
					return html;
				} else if (params.dataType === "edge") {
					return `<strong style="color: #3B82F6;">${params.data.source}</strong><br/>→<br/><strong style="color: #3B82F6;">${params.data.target}</strong><br/><span style="color: #999;">Strength: ${params.data.value}</span>`;
				}
			},
		},
		legend: {
			data: categories.map((cat) => ({ name: cat.name })),
			left: "left",
			top: "top",
			textStyle: {
				color: "#ccc",
				fontSize: 12,
			},
			backgroundColor: "rgba(20, 25, 45, 0.85)",
			borderColor: "#3B82F6",
			borderWidth: 1.5,
			padding: [10, 15],
			itemGap: 12,
			orient: "vertical",
			align: "auto",
		},
		animationDuration: 1500,
		animationEasingUpdate: "quinticInOut",
		series: [
			{
				name: "Network Topology",
				type: "graph",
				layout: "force",
				data: networkNodes,
				links: networkLinks,
				categories: categories,
				roam: true,
				label: {
					show: true,
					position: "inside",
					formatter: (params) => {
						const name = params.data.name;
						// Truncate long names to fit inside nodes
						return name.length > 12 ? name.substring(0, 10) + ".." : name;
					},
					fontSize: 10,
					color: "#fff",
					fontWeight: "bold",
					overflow: "truncate",
				},
				itemStyle: {
					borderColor: "#fff",
					borderWidth: 2,
					shadowColor: "rgba(59, 130, 246, 0.6)",
					shadowBlur: 15,
					shadowOffsetX: 0,
					shadowOffsetY: 0,
				},
				lineStyle: {
					color: "#555",
					width: 2,
					curveness: 0.3,
					opacity: 0.6,
				},
				emphasis: {
					focus: "adjacency",
					lineStyle: {
						width: 3,
						color: "#60a5fa",
						opacity: 1,
					},
					itemStyle: {
						borderColor: "#60a5fa",
						borderWidth: 3,
						shadowColor: "#3B82F6",
						shadowBlur: 25,
						shadowOffsetX: 0,
						shadowOffsetY: 0,
					},
				},
				force: {
					repulsion: 250,
					gravity: 0.02,
					edgeLength: [120, 180],
					layoutAnimation: true,
					friction: 0.4,
				},
			},
		],
		backgroundColor: "#1a1f35",
	};

	return (
		<div style={{ width: "100%", height: "600px", overflow: "hidden" }}>
			<ECharts option={option} style={{ width: "100%", height: "100%" }} />
		</div>
	);
}
